export default __webpack_public_path__ + "static/media/Red0006.e0bc5bec.png";